<template>
  <van-popup v-model:show="visible" closeable position="bottom" :style="{ width: '100%' }">
    <div class="replace-dialog" @click.stop>
      <div class="dialog-title">极速补办</div>
      <div class="dialog-content">
        <!-- 图形验证码 -->
        <div class="form-item">
          <div class="form-label">
            <span class="all_tips_red"></span>
            <span>图形验证码</span>
          </div>
          <div class="form-input-box">
            <van-field v-model="imgVerifyCode" type="number" maxlength="6" placeholder="请输入计算结果" clearable
              class="form-input" />
            <img :src="verifyImg" class="verify-img" @click="getPictureImg" title="看不清，点击刷新" />
          </div>
        </div>

        <!-- 短信验证码 -->
        <div class="form-item">
          <div class="form-label">
            <span class="all_tips_red"></span>
            <span>短信验证码</span>
          </div>
          <div class="form-input-box">
            <van-field v-model="smsCode" type="number" maxlength="6" placeholder="请输入验证码" clearable
              class="form-input" />
            <span class="get-code-btn" :class="{ disabled: timer !== 60 }" @click="getSmsCode">
              {{ timer === 60 ? '获取验证码' : timer + 's后重试' }}
            </span>
          </div>
        </div>

        <!-- 补办原因 -->
        <div class="form-item">
          <div class="form-label">
            <span class="all_tips_red"></span>
            <span>补办原因</span>
          </div>
          <van-field v-model="applyMemo" rows="2" autosize type="textarea" maxlength="200" placeholder="请输入补办原因"
            show-word-limit class="form-textarea" />
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <button class="btn-confirm" @click="handleConfirm">确定</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Vue from 'vue';
import { Field, Popup } from 'vant';

Vue.use(Field);
Vue.use(Popup);

export default {
  name: 'ReplaceCertDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 证书信息
    certInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: this.show,
      // 图形验证码
      imgVerifyCode: '',
      // 图形验证码ID
      verifyId: '',
      // 图形验证码图片
      verifyImg: '',
      // 短信验证码
      smsCode: '',
      // 补办原因
      applyMemo: '',
      // 倒计时
      timer: 60,
      // 倒计时定时器
      countdownTimer: null
    };
  },
  watch: {
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
    visible(val) {
      this.$emit('update:show', val);
    }
  },
  methods: {
    // 初始化
    init() {
      // 清除之前的倒计时定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.imgVerifyCode = '';
      this.smsCode = '';
      this.applyMemo = '';
      this.timer = 60;
      this.getPictureImg();
    },

    // 获取图形验证码
    getPictureImg() {
      this.imgVerifyCode = '';
      this.$store.dispatch(this.$LoadShow, true);
      this.$get('/login/api/getPictureImg')
        .then((res) => {
          this.$store.dispatch(this.$LoadShow, false);
          if (res.success && res.data) {
            this.verifyId = res.data.verifyId;
            this.verifyImg = res.data.srcImg;
          } else {
            this.verifyImg = '';
            this.$Toast('未获取到验证图片！');
          }
        })
        .catch((err) => {
          this.verifyImg = '';
          this.$store.dispatch(this.$LoadShow, false);
          console.log('getPictureImg error:', err);
          this.$Toast('获取验证图片失败！');
        });
    },

    // 获取短信验证码
    getSmsCode() {
      if (this.timer !== 60) {
        return;
      }

      // 验证图形验证码
      if (!this.imgVerifyCode) {
        this.$Toast('请输入图形验证码！');
        return;
      }

      // 获取手机号
      const mobile = this.$store.state.userInfo?.mobile;
      if (!mobile) {
        this.$Toast('未获取到用户手机号！');
        return;
      }

      this.$store.dispatch(this.$LoadShow, true);
      this.$post('/my/api/sendSmsCode', {
        mobile: mobile,
        type: 7, // type：1 登录、2 忘记密码、3 重置密码、4 更换手机号 5、个人认证 7、证书补办认证
        verify: {
          code: this.imgVerifyCode,
          id: this.verifyId
        }
      })
        .then((res) => {
          this.$store.dispatch(this.$LoadShow, false);
          if (res.success) {
            this.$Toast('验证码已发送，请注意查收！');
            this.startCountdown();
          } else {
            this.$Toast(res.message || '获取验证码失败！');
            this.getPictureImg();
          }
        })
        .catch((err) => {
          this.$store.dispatch(this.$LoadShow, false);
          console.log('sendSmsCode error:', err);
          this.$Toast('获取验证码失败！');
          this.getPictureImg();
        });
    },

    // 开始倒计时
    startCountdown() {
      // 先清除已有的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.timer--;
      this.countdownTimer = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          this.timer = 60;
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },

    // 取消
    handleCancel() {
      this.closeDialog();
    },

    // 确定
    handleConfirm() {
      // 表单验证
      if (!this.imgVerifyCode) {
        this.$Toast('请输入图形验证码！');
        return;
      }
      if (!this.smsCode) {
        this.$Toast('请输入短信验证码！');
        return;
      }
      if (!this.applyMemo) {
        this.$Toast('请输入补办原因！');
        return;
      }

      // 提交数据
      const params = {
        certId: this.certInfo.certId,
        smsCode: this.smsCode,
        applyMemo: this.applyMemo
      };

      this.$emit('confirm', params);
    },

    // 关闭弹框
    closeDialog() {
      // 清除倒计时定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.timer = 60;
      this.visible = false;
    },
    // 关闭弹框（兼容旧方法）
    close() {
      this.closeDialog();
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/global.css";

.replace-dialog {
  padding: 1rem 0.8rem 1.5rem;

  .dialog-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #333;
    text-align: center;
    margin-bottom: 0.8rem;
  }

  .dialog-content {
    .form-item {
      margin-bottom: 0.5rem;

      .form-label {
        font-size: 0.7rem;
        color: #666;
        margin-bottom: 0.3rem;
        line-height: 1.2rem;
      }

      .form-input-box {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 0.1rem;

        .form-input {
          flex: 1;
        }

        .verify-img {
          width: 4rem;
          height: 1.5rem;
          cursor: pointer;
        }

        .get-code-btn {
          white-space: nowrap;
          font-size: 0.65rem;
          color: #0277FC;
          padding: 0 0.3rem;
          line-height: 1.4rem;
          border-left: 1px solid #ccc;
          margin-left: 0.3rem;
          padding-left: 0.5rem;

          &.disabled {
            color: #999;
          }
        }
      }

      .form-textarea {
        border: 1px solid #ccc;
        border-radius: 0.2rem;
        margin-top: 0.3rem;
        padding: 0.3rem;
      }
    }
  }

  .dialog-footer {
    margin-top: 1rem;

    .btn-confirm {
      width: 100%;
      height: 2.2rem;
      border-radius: 0.2rem;
      font-size: 0.8rem;
      background-color: #0277FC;
      color: #fff;
    }
  }
}

::v-deep .van-field {
  padding: 0.3rem 0;

  .van-field__control {
    font-size: 0.7rem;
  }
}

::v-deep .van-field--textarea {
  padding: 0.3rem;

  .van-field__control {
    font-size: 0.7rem;
  }
}
</style>